export default __webpack_public_path__ + "static/RichardFife-2170b278d9fefc458cede68cfebda62e.jpg";